import React, { Component } from "react";
import axios from "axios";
import { customAlphabet } from "nanoid";
import validator from "validator";
import { withRouter } from "react-router-dom";
import baseurl from "./baseurl";
import ToolTipIcon from "../imgs/tooltip.svg";
import "../styles/Form3.css";

const RECORD_TYPES = [
  "Medical Records Abstract",
  "History and Physical",
  "Discharge Summary",
  "Consultation Report(s)",
  "Outpatient/Physician Office Records",
  "ER Record",
  "Operative Report(s)",
  "Radiology Report(s)",
  "Laboratory Report(s)",
  "Pathology Report(s)",
  "Outpatient Clinic Notes",
  "Cardiology Report(s)",
  "Hospital Admission",
  "Physician Office Note(s)",
  "Face Sheet",
  "Billing Record(s)",
  "Radiology Image(s)",
  "Computer-Readable Export",
];

const PURPOSE_OPTIONS = [
  "Treatment/Continuing Medical Care",
  "Personal Reasons",
  "Insurance Purposes",
  "Immunization",
  "Legal Purposes",
  "Employer Requirement",
  "Other",
];

const DELIVERY_OPTIONS = [
  "Electronic copy of records",
  "Fax to 972-408-4411",
  "Mail Paper Records",
  "CD/DVD",
  "Pickup on Site",
];

const RECIPIENT_DEFAULTS = [
  "Dr. Yamini Maddala",
  "DHPT",
];

const RECIPIENT_DEFAULT_INFO = {
  personOrganization: "Dr. Yamini Maddala | Digestive Health (DHPT)",
  address: "210 S Preston Road, Suite 30",
  city: "Prosper",
  state: "TX",
  zip: "75013",
  phone: "972-408-4400",
  fax: "972-408-4422",
  email: "mr@dhptx.com",
};

const FACILITY_DEFAULT_INFO = {
  personOrganization: "GI Alliance (GIA) | DHAT | TDDC",
  address: "",
  city: "",
  state: "",
  zip: "",
  phone: "1-800-659-4035",
  fax: "1-800-833-5935",
  email: "status@healthmark-group.com",
};

class Form3 extends Component {
  nanoid = customAlphabet("1234567890", 8);

  state = {
    pid: this.nanoid(),
    // Patient Info
    firstName: "",
    mi: "",
    lastName: "",
    maidenName: "",
    dob: "",
    phoneHome: "",
    phoneCell: "",
    confirmPhone: "",
    email: "",
    confirmEmail: "",
    mailingAddress: "",
    apt: "",
    city: "",
    patientState: "",
    zipCode: "",
    // Information to Release
    releaseAll: true,
    selectedRecords: [...RECORD_TYPES],
    otherRecords: "",
    purpose: "Treatment/Continuing Medical Care",
    // Facilities
    facilityType: "gia",
    facilityName: "",
    // Recipient
    recipientType: "",
    selectedRecipients: [...RECIPIENT_DEFAULTS],
    recipientFirstName: "",
    recipientLastName: "",
    recipientPhone: "",
    recipientEmail: "",
    recipientAddress: "",
    recipientApt: "",
    recipientCity: "",
    recipientState: "",
    recipientZip: "",
    recipientFax: "",
    // Delivery
    deliveryMethod: "Electronic copy of records",
    // Additional
    additionalInfo: "",
    // Identity Verification
    idFile: null,
    idFileName: "",
    // UI
    errorMessage: "",
    loading: false,
    submitted: false,
  };

  onChange = (e) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  onPhoneChange = (e) => {
    let input = e.target.value.replace(/\D/g, "");
    if (input.length > 10) input = input.substring(0, 10);
    let formatted = "";
    if (input.length > 6) {
      formatted = input.substring(0, 3) + "-" + input.substring(3, 6) + "-" + input.substring(6);
    } else if (input.length > 3) {
      formatted = input.substring(0, 3) + "-" + input.substring(3);
    } else {
      formatted = input;
    }
    this.setState({ [e.target.name]: formatted });
  };

  isValidPhone = (phone) => {
    return /^\d{3}-\d{3}-\d{4}$/.test(phone);
  };

  isValidZip = (zip) => {
    return /^\d{5}(-\d{4})?$/.test(zip);
  };

  onZipChange = (e) => {
    let input = e.target.value.replace(/[^\d-]/g, "");
    if (input.length > 10) input = input.substring(0, 10);
    const digits = input.replace(/-/g, "");
    if (digits.length <= 5) {
      input = digits;
    } else {
      input = digits.substring(0, 5) + "-" + digits.substring(5, 9);
    }
    this.setState({ [e.target.name]: input });
  };

  onRecordToggle = (record) => {
    this.setState((prev) => {
      const selected = prev.selectedRecords.includes(record)
        ? prev.selectedRecords.filter((r) => r !== record)
        : [...prev.selectedRecords, record];
      return { selectedRecords: selected };
    });
  };

  onReleaseAllToggle = () => {
    this.setState((prev) => {
      if (prev.releaseAll) {
        return { releaseAll: false, selectedRecords: [] };
      }
      return { releaseAll: true, selectedRecords: [...RECORD_TYPES] };
    });
  };

  onRecipientToggle = (recipient) => {
    this.setState((prev) => {
      const selected = prev.selectedRecipients.includes(recipient)
        ? prev.selectedRecipients.filter((r) => r !== recipient)
        : [...prev.selectedRecipients, recipient];
      return { selectedRecipients: selected };
    });
  };

  onFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ idFile: file, idFileName: file.name });
    }
  };

  handleAlert = () => {
    this.setState({ errorMessage: "" });
  };

  redirect = () => {
    this.props.history.push("/thank-you");
  };

  validate = () => {
    const s = this.state;
    let hasError = false;
    if (!s.firstName || !s.lastName || !s.dob || !s.phoneCell || !s.email) hasError = true;
    if (s.phoneCell && !this.isValidPhone(s.phoneCell)) hasError = true;
    if (s.phoneHome && !this.isValidPhone(s.phoneHome)) hasError = true;
    if (!s.confirmPhone || s.phoneCell !== s.confirmPhone) hasError = true;
    if (!s.confirmEmail || s.email !== s.confirmEmail) hasError = true;
    if (s.email && !validator.isEmail(s.email)) hasError = true;
    if (!s.mailingAddress || !s.city || !s.patientState || !s.zipCode) hasError = true;
    if (s.zipCode && !this.isValidZip(s.zipCode)) hasError = true;
    if (s.selectedRecords.length === 0) hasError = true;
    if (!s.purpose) hasError = true;
    if (s.facilityType === "other" && !s.facilityName) hasError = true;
    if (!s.recipientType && s.selectedRecipients.length === 0) hasError = true;
    if (s.recipientType === "other") {
      if (!s.recipientFirstName || !s.recipientLastName || !s.recipientPhone) hasError = true;
      if (!s.recipientAddress || !s.recipientCity || !s.recipientState || !s.recipientZip) hasError = true;
    }
    if (!s.deliveryMethod) hasError = true;
    return hasError;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submitted: true });
    if (this.validate()) {
      window.scrollTo(0, 0);
      return;
    }

    this.setState({ loading: true, errorMessage: "" });

    try {
      const formData = new FormData();
      // Patient Info
      formData.append("pid", this.state.pid);
      formData.append("firstName", this.state.firstName);
      formData.append("mi", this.state.mi);
      formData.append("lastName", this.state.lastName);
      formData.append("maidenName", this.state.maidenName);
      formData.append("dob", this.state.dob);
      formData.append("phoneHome", this.state.phoneHome);
      formData.append("phoneCell", this.state.phoneCell);
      formData.append("email", this.state.email);
      formData.append("mailingAddress", this.state.mailingAddress);
      formData.append("apt", this.state.apt);
      formData.append("city", this.state.city);
      formData.append("patientState", this.state.patientState);
      formData.append("zipCode", this.state.zipCode);
      // Records
      formData.append("releaseAll", this.state.releaseAll ? "true" : "false");
      formData.append(
        "selectedRecords",
        JSON.stringify(this.state.selectedRecords)
      );
      formData.append("otherRecords", this.state.otherRecords);
      formData.append("purpose", this.state.purpose);
      // Facility
      formData.append("facilityType", this.state.facilityType);
      formData.append("facilityName", this.state.facilityType === "gia" ? "GI Alliance (GIA)" : this.state.facilityName);
      // Recipient
      formData.append("recipientType", this.state.recipientType);
      formData.append("selectedRecipients", JSON.stringify(this.state.selectedRecipients));
      if (this.state.recipientType === "other") {
        formData.append("recipientFirstName", this.state.recipientFirstName);
        formData.append("recipientLastName", this.state.recipientLastName);
        formData.append("recipientPhone", this.state.recipientPhone);
        formData.append("recipientEmail", this.state.recipientEmail);
        formData.append("recipientAddress", this.state.recipientAddress);
        formData.append("recipientApt", this.state.recipientApt);
        formData.append("recipientCity", this.state.recipientCity);
        formData.append("recipientState", this.state.recipientState);
        formData.append("recipientZip", this.state.recipientZip);
        formData.append("recipientFax", this.state.recipientFax);
      }
      // Delivery
      formData.append("deliveryMethod", this.state.deliveryMethod);
      // Additional
      formData.append("additionalInfo", this.state.additionalInfo);
      // File
      formData.append("idFile", this.state.idFile);

      const response = await axios.post(
        `${baseurl}/form3/transfer-medical-records`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.status === 200) {
        this.setState({ loading: false });
        this.redirect();
      }
    } catch (err) {
      this.setState({
        loading: false,
        errorMessage: "Something went wrong, please try again later",
      });
    }
  };

  render() {
    const { submitted } = this.state;
    return (
      <div>
        <div className="form3-main">
          <div className="form3-wrapper">
            <h1 className="form3-title">
              Request for Release of Medical Records
            </h1>
            <p className="form3-required-legend">
              Fields marked with <span className="form3-dot">*</span> are
              required.
            </p>
            <p className="form3-required-legend">
              Please fill only the "Patient Information" section. The other sections below do not need to be filled as they have default values.
            </p>

            {/* Error Alert */}
            {this.state.errorMessage && (
              <div className="alert">
                <span className="closebtn" onClick={this.handleAlert}>
                  &times;
                </span>
                {this.state.errorMessage}
              </div>
            )}

            <form onSubmit={this.onSubmit} className="form3-form" noValidate>
              {/* ============ SECTION: Patient Information ============ */}
              <section className="form3-section form3-section-highlight">
                <h2 className="form3-section-heading">
                  Patient Information
                  <div className="form3-tooltip">
                    <span className="icon">
                      <img
                        src={ToolTipIcon}
                        width="20px"
                        height="20px"
                        alt="Information"
                      />
                    </span>
                    <span className="text">
                      Please enter the patient information you want medical records transferred.
                    </span>
                  </div>
                </h2>
                <div className="form3-row form3-row-5">
                  <div className="form3-field">
                    <label>
                      First Name<span className="mandate">*</span>
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      maxLength="20"
                      onChange={this.onChange}
                      value={this.state.firstName}
                      className={submitted && !this.state.firstName ? "form3-input-error" : ""}
                    />
                    {submitted && !this.state.firstName && (
                      <span className="form3-error">Please provide a first name</span>
                    )}
                  </div>
                  <div className="form3-field form3-field-sm">
                    <label>MI</label>
                    <input
                      type="text"
                      name="mi"
                      maxLength="1"
                      onChange={this.onChange}
                      value={this.state.mi}
                    />
                  </div>
                  <div className="form3-field">
                    <label>
                      Last Name<span className="mandate">*</span>
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      maxLength="20"
                      onChange={this.onChange}
                      value={this.state.lastName}
                      className={submitted && !this.state.lastName ? "form3-input-error" : ""}
                    />
                    {submitted && !this.state.lastName && (
                      <span className="form3-error">Please provide a last name</span>
                    )}
                  </div>
                  <div className="form3-field">
                    <label>Maiden or Other Name</label>
                    <input
                      type="text"
                      name="maidenName"
                      maxLength="20"
                      onChange={this.onChange}
                      value={this.state.maidenName}
                    />
                  </div>
                  <div className="form3-field">
                    <label>
                      Date of Birth<span className="mandate">*</span>
                    </label>
                    <input
                      type="date"
                      name="dob"
                      max={new Date().toISOString().split("T")[0]}
                      onChange={this.onChange}
                      value={this.state.dob}
                      className={submitted && !this.state.dob ? "form3-input-error" : ""}
                    />
                    {submitted && !this.state.dob && (
                      <span className="form3-error">DOB is required</span>
                    )}
                  </div>
                </div>
                <div className="form3-row form3-row-3">
                  <div className="form3-field">
                    <label>
                      Phone (cell)<span className="mandate">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phoneCell"
                      placeholder="000-000-0000"
                      maxLength="12"
                      onChange={this.onPhoneChange}
                      value={this.state.phoneCell}
                      className={submitted && (!this.state.phoneCell || !this.isValidPhone(this.state.phoneCell)) ? "form3-input-error" : ""}
                    />
                    {submitted && !this.state.phoneCell && (
                      <span className="form3-error">Please provide a cell phone number</span>
                    )}
                    {submitted && this.state.phoneCell && !this.isValidPhone(this.state.phoneCell) && (
                      <span className="form3-error">Please enter valid phone number (000-000-0000)</span>
                    )}
                  </div>
                  <div className="form3-field">
                    <label>
                      Confirm Phone (cell)<span className="mandate">*</span>
                    </label>
                    <input
                      type="tel"
                      name="confirmPhone"
                      placeholder="000-000-0000"
                      maxLength="12"
                      onChange={this.onPhoneChange}
                      value={this.state.confirmPhone}
                      className={submitted && (!this.state.confirmPhone || this.state.phoneCell !== this.state.confirmPhone) ? "form3-input-error" : ""}
                    />
                    {submitted && !this.state.confirmPhone && (
                      <span className="form3-error">Please confirm your phone number</span>
                    )}
                    {submitted && this.state.confirmPhone && this.state.phoneCell !== this.state.confirmPhone && (
                      <span className="form3-error">Phone numbers do not match</span>
                    )}
                  </div>
                  <div className="form3-field">
                    <label>
                      Phone (home)
                    </label>
                    <input
                      type="tel"
                      name="phoneHome"
                      placeholder="000-000-0000"
                      maxLength="12"
                      onChange={this.onPhoneChange}
                      value={this.state.phoneHome}
                    />
                    {submitted && this.state.phoneHome && !this.isValidPhone(this.state.phoneHome) && (
                      <span className="form3-error">Please enter valid phone number (000-000-0000)</span>
                    )}
                  </div>
                </div>
                <div className="form3-row form3-row-2">
                  <div className="form3-field">
                    <label>
                      Email<span className="mandate">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      maxLength="40"
                      onChange={this.onChange}
                      value={this.state.email}
                      className={submitted && (!this.state.email || !validator.isEmail(this.state.email)) ? "form3-input-error" : ""}
                    />
                    {submitted && !this.state.email && (
                      <span className="form3-error">Please provide an email address</span>
                    )}
                    {submitted && this.state.email && !validator.isEmail(this.state.email) && (
                      <span className="form3-error">Please enter a valid email</span>
                    )}
                  </div>
                  <div className="form3-field">
                    <label>
                      Confirm Email<span className="mandate">*</span>
                    </label>
                    <input
                      type="email"
                      name="confirmEmail"
                      maxLength="40"
                      onChange={this.onChange}
                      value={this.state.confirmEmail}
                      className={submitted && (!this.state.confirmEmail || this.state.email !== this.state.confirmEmail) ? "form3-input-error" : ""}
                    />
                    {submitted && !this.state.confirmEmail && (
                      <span className="form3-error">Please confirm your email address</span>
                    )}
                    {submitted && this.state.confirmEmail && this.state.email !== this.state.confirmEmail && (
                      <span className="form3-error">Emails do not match</span>
                    )}
                  </div>
                </div>
                <div className="form3-row form3-row-2">
                  <div className="form3-field form3-field-lg">
                    <label>
                      Mailing Address<span className="mandate">*</span>
                    </label>
                    <input
                      type="text"
                      name="mailingAddress"
                      maxLength="40"
                      onChange={this.onChange}
                      value={this.state.mailingAddress}
                      className={submitted && !this.state.mailingAddress ? "form3-input-error" : ""}
                    />
                    {submitted && !this.state.mailingAddress && (
                      <span className="form3-error">Please provide an address</span>
                    )}
                  </div>
                  <div className="form3-field form3-field-lg">
                    <label>Apt, PO Box, etc. (optional)</label>
                    <input
                      type="text"
                      name="apt"
                      maxLength="40"
                      onChange={this.onChange}
                      value={this.state.apt}
                    />
                  </div>
                </div>
                <div className="form3-row form3-row-3">
                  <div className="form3-field">
                    <label>
                      City<span className="mandate">*</span>
                    </label>
                    <input
                      type="text"
                      name="city"
                      maxLength="20"
                      onChange={this.onChange}
                      value={this.state.city}
                      className={submitted && !this.state.city ? "form3-input-error" : ""}
                    />
                    {submitted && !this.state.city && (
                      <span className="form3-error">Please provide a city</span>
                    )}
                  </div>
                  <div className="form3-field">
                    <label>
                      State<span className="mandate">*</span>
                    </label>
                    <input
                      type="text"
                      name="patientState"
                      maxLength="2"
                      onChange={this.onChange}
                      value={this.state.patientState}
                      className={submitted && !this.state.patientState ? "form3-input-error" : ""}
                    />
                    {submitted && !this.state.patientState && (
                      <span className="form3-error">Please provide a state</span>
                    )}
                  </div>
                  <div className="form3-field">
                    <label>
                      Zip Code<span className="mandate">*</span>
                    </label>
                    <input
                      type="text"
                      name="zipCode"
                      placeholder="00000"
                      maxLength="10"
                      onChange={this.onZipChange}
                      value={this.state.zipCode}
                      className={submitted && (!this.state.zipCode || !this.isValidZip(this.state.zipCode)) ? "form3-input-error" : ""}
                    />
                    {submitted && !this.state.zipCode && (
                      <span className="form3-error">Please provide a zip code</span>
                    )}
                    {submitted && this.state.zipCode && !this.isValidZip(this.state.zipCode) && (
                      <span className="form3-error">Please enter a valid zip code (00000 or 00000-0000)</span>
                    )}
                  </div>
                </div>
              </section>

              {/* ============ SECTION: Information To Release ============ */}
              <section className="form3-section">
                <h2 className="form3-section-heading">
                  Information To Release
                  <div className="form3-tooltip">
                    <span className="icon">
                      <img
                        src={ToolTipIcon}
                        width="20px"
                        height="20px"
                        alt="Information"
                      />
                    </span>
                    <span className="text">
                      The default selection is 'Release All of my Records'. Please select different options if you only want a certain type of records transferred.
                    </span>
                  </div>
                </h2>
                <p className="form3-instruction">
                  Select the medical information you would like released
                </p>
                <div className="form3-pill-group">
                  <label className={`form3-pill form3-pill-all ${this.state.releaseAll ? "form3-pill-selected" : ""}`}>
                    <input
                      type="checkbox"
                      checked={this.state.releaseAll}
                      onChange={this.onReleaseAllToggle}
                    />
                    <span>Release All of my Records</span>
                  </label>
                  {RECORD_TYPES.map((record) => (
                    <label className={`form3-pill ${this.state.selectedRecords.includes(record) ? "form3-pill-selected" : ""}`} key={record}>
                      <input
                        type="checkbox"
                        checked={this.state.selectedRecords.includes(record)}
                        onChange={() => this.onRecordToggle(record)}
                      />
                      <span>{record}</span>
                    </label>
                  ))}
                </div>
                {submitted && this.state.selectedRecords.length === 0 && (
                  <span className="form3-error">You must select at least one item for release</span>
                )}
                <div className="form3-row form3-row-1" style={{ marginTop: "15px" }}>
                  <div className="form3-field form3-field-full">
                    <label>Other (Maximum of 500 characters)</label>
                    <input
                      type="text"
                      name="otherRecords"
                      maxLength="500"
                      onChange={this.onChange}
                      value={this.state.otherRecords}
                    />
                  </div>
                </div>
                <div className="form3-submit-all-checkbox">
                  <input
                    type="checkbox"
                    checked={true}
                    disabled
                    id="submitAllRecords"
                  />
                  <label htmlFor="submitAllRecords">Submit all records</label>
                </div>
                <p className="form3-instruction" style={{ marginTop: "20px" }}>
                  Select the purpose for which disclosure is authorized
                </p>
                <div className="form3-pill-group">
                  {PURPOSE_OPTIONS.map((opt) => (
                    <label className={`form3-pill ${this.state.purpose === opt ? "form3-pill-selected" : ""}`} key={opt}>
                      <input
                        type="radio"
                        name="purpose"
                        value={opt}
                        checked={this.state.purpose === opt}
                        onChange={this.onChange}
                      />
                      <span>{opt}</span>
                    </label>
                  ))}
                </div>
                {submitted && !this.state.purpose && (
                  <span className="form3-error">You must specify the purpose for the disclosure</span>
                )}
              </section>

              {/* ============ SECTION: Facilities ============ */}
              <section className="form3-section">
                <h2 className="form3-section-heading">
                  Facilities Releasing Information
                  <div className="form3-tooltip">
                    <span className="icon">
                      <img
                        src={ToolTipIcon}
                        width="20px"
                        height="20px"
                        alt="Information"
                      />
                    </span>
                    <span className="text">
                      This selection identified the group, provider, clinic or hospital sending the information.
                    </span>
                  </div>
                </h2>
                <p className="form3-instruction">
                  Select the parties from which you'd like to receive the
                  requested medical information
                </p>
                <div className="form3-pill-group">
                  <label className={`form3-pill ${this.state.facilityType === "gia" ? "form3-pill-selected" : ""}`}>
                    <input
                      type="radio"
                      name="facilityType"
                      value="gia"
                      checked={this.state.facilityType === "gia"}
                      onChange={this.onChange}
                    />
                    <span>GI Alliance (GIA)</span>
                  </label>
                  <div className="form3-tooltip">
                    <span className="icon">
                      <img
                        src={ToolTipIcon}
                        width="16px"
                        height="16px"
                        alt="Information"
                      />
                    </span>
                    <span className="text">
                      The default selection is 'GI Alliance (GIA)'. Please unselect GI Alliance (GIA) and select "Other" to enter a provider, clinic, or hospital name.
                    </span>
                  </div>
                  <label className={`form3-pill ${this.state.facilityType === "other" ? "form3-pill-selected" : ""}`}>
                    <input
                      type="radio"
                      name="facilityType"
                      value="other"
                      checked={this.state.facilityType === "other"}
                      onChange={this.onChange}
                    />
                    <span>Other</span>
                  </label>
                </div>
                {this.state.facilityType === "gia" && (
                  <div className="form3-recipient-fields form3-recipient-readonly">
                    <div className="form3-row form3-row-1">
                      <div className="form3-field">
                        <label>Person/Organization</label>
                        <input type="text" value={FACILITY_DEFAULT_INFO.personOrganization} disabled />
                      </div>
                    </div>
                    <div className="form3-row form3-row-4">
                      <div className="form3-field" style={{ flex: 2 }}>
                        <label>Address</label>
                        <input type="text" value={FACILITY_DEFAULT_INFO.address} disabled />
                      </div>
                      <div className="form3-field">
                        <label>City</label>
                        <input type="text" value={FACILITY_DEFAULT_INFO.city} disabled />
                      </div>
                      <div className="form3-field" style={{ maxWidth: "80px" }}>
                        <label>State</label>
                        <input type="text" value={FACILITY_DEFAULT_INFO.state} disabled />
                      </div>
                      <div className="form3-field" style={{ maxWidth: "100px" }}>
                        <label>Zip</label>
                        <input type="text" value={FACILITY_DEFAULT_INFO.zip} disabled />
                      </div>
                    </div>
                    <div className="form3-row form3-row-3">
                      <div className="form3-field">
                        <label>Phone</label>
                        <input type="tel" value={FACILITY_DEFAULT_INFO.phone} disabled />
                      </div>
                      <div className="form3-field">
                        <label>Fax</label>
                        <input type="tel" value={FACILITY_DEFAULT_INFO.fax} disabled />
                      </div>
                      <div className="form3-field">
                        <label>Email</label>
                        <input type="email" value={FACILITY_DEFAULT_INFO.email} disabled />
                      </div>
                    </div>
                  </div>
                )}
                {this.state.facilityType === "other" && (
                  <div className="form3-row form3-row-1" style={{ marginTop: "15px" }}>
                    <div className="form3-field form3-field-full">
                      <label>
                        Provider, Clinic, or Hospital<span className="mandate">*</span>
                      </label>
                      <input
                        type="text"
                        name="facilityName"
                        maxLength="100"
                        onChange={this.onChange}
                        value={this.state.facilityName}
                        className={submitted && !this.state.facilityName ? "form3-input-error" : ""}
                      />
                      {submitted && !this.state.facilityName && (
                        <span className="form3-error">Please provide a provider, clinic, or hospital name</span>
                      )}
                    </div>
                  </div>
                )}
              </section>

              {/* ============ SECTION: Recipient of Information ============ */}
              <section className="form3-section">
                <h2 className="form3-section-heading">
                  Recipient of Information
                  <div className="form3-tooltip">
                    <span className="icon">
                      <img
                        src={ToolTipIcon}
                        width="20px"
                        height="20px"
                        alt="Information"
                      />
                    </span>
                    <span className="text">
                      The selection identifies where the medical records information is being sent. The default selection is DHPT and Dr. Yamini Maddala.
                    </span>
                  </div>
                </h2>
                <p className="form3-instruction">
                  To whom will the records be disclosed?
                </p>
                <div className="form3-pill-group" style={{ marginBottom: "10px" }}>
                  {RECIPIENT_DEFAULTS.map((r) => (
                    <label className={`form3-pill ${this.state.selectedRecipients.includes(r) ? "form3-pill-selected" : ""}`} key={r}>
                      <input
                        type="checkbox"
                        checked={this.state.selectedRecipients.includes(r)}
                        onChange={() => this.onRecipientToggle(r)}
                      />
                      <span>{r}</span>
                    </label>
                  ))}
                </div>
                {(this.state.selectedRecipients.includes("DHPT") || this.state.selectedRecipients.includes("Dr. Yamini Maddala")) && (
                  <div className="form3-recipient-fields form3-recipient-readonly">
                    <div className="form3-row form3-row-1">
                      <div className="form3-field">
                        <label>Person/Organization</label>
                        <input type="text" value={RECIPIENT_DEFAULT_INFO.personOrganization} disabled />
                      </div>
                    </div>
                    <div className="form3-row form3-row-4">
                      <div className="form3-field" style={{ flex: 2 }}>
                        <label>Address</label>
                        <input type="text" value={RECIPIENT_DEFAULT_INFO.address} disabled />
                      </div>
                      <div className="form3-field">
                        <label>City</label>
                        <input type="text" value={RECIPIENT_DEFAULT_INFO.city} disabled />
                      </div>
                      <div className="form3-field" style={{ maxWidth: "80px" }}>
                        <label>State</label>
                        <input type="text" value={RECIPIENT_DEFAULT_INFO.state} disabled />
                      </div>
                      <div className="form3-field" style={{ maxWidth: "100px" }}>
                        <label>Zip</label>
                        <input type="text" value={RECIPIENT_DEFAULT_INFO.zip} disabled />
                      </div>
                    </div>
                    <div className="form3-row form3-row-3">
                      <div className="form3-field">
                        <label>Phone</label>
                        <input type="tel" value={RECIPIENT_DEFAULT_INFO.phone} disabled />
                      </div>
                      <div className="form3-field">
                        <label>Fax</label>
                        <input type="tel" value={RECIPIENT_DEFAULT_INFO.fax} disabled />
                      </div>
                      <div className="form3-field">
                        <label>Email</label>
                        <input type="email" value={RECIPIENT_DEFAULT_INFO.email} disabled />
                      </div>
                    </div>
                  </div>
                )}
                <div className="form3-pill-group">
                  <label className={`form3-pill ${this.state.recipientType === "patient" ? "form3-pill-selected" : ""}`}>
                    <input
                      type="checkbox"
                      checked={this.state.recipientType === "patient"}
                      onChange={() => this.setState((prev) => ({ recipientType: prev.recipientType === "patient" ? "" : "patient" }))}
                    />
                    <span>Patient (You)</span>
                  </label>
                  <label className={`form3-pill ${this.state.recipientType === "other" ? "form3-pill-selected" : ""}`}>
                    <input
                      type="checkbox"
                      checked={this.state.recipientType === "other"}
                      onChange={() => this.setState((prev) => ({ recipientType: prev.recipientType === "other" ? "" : "other" }))}
                    />
                    <span>Someone else</span>
                  </label>
                </div>
                {submitted && !this.state.recipientType && this.state.selectedRecipients.length === 0 && (
                  <span className="form3-error">Please specify the party to whom the records should be disclosed</span>
                )}
                {this.state.recipientType === "other" && (
                  <div className="form3-recipient-fields">
                    <p className="form3-instruction">
                      Please provide the contact information for the person or
                      entity receiving the records
                    </p>
                    <div className="form3-row form3-row-2">
                      <div className="form3-field">
                        <label>
                          Recipient First Name
                          <span className="mandate">*</span>
                        </label>
                        <input
                          type="text"
                          name="recipientFirstName"
                          maxLength="20"
                          onChange={this.onChange}
                          value={this.state.recipientFirstName}
                          className={submitted && !this.state.recipientFirstName ? "form3-input-error" : ""}
                        />
                        {submitted && !this.state.recipientFirstName && (
                          <span className="form3-error">Please provide a first name</span>
                        )}
                      </div>
                      <div className="form3-field">
                        <label>
                          Recipient Last Name
                          <span className="mandate">*</span>
                        </label>
                        <input
                          type="text"
                          name="recipientLastName"
                          maxLength="20"
                          onChange={this.onChange}
                          value={this.state.recipientLastName}
                          className={submitted && !this.state.recipientLastName ? "form3-input-error" : ""}
                        />
                        {submitted && !this.state.recipientLastName && (
                          <span className="form3-error">Please provide a last name</span>
                        )}
                      </div>
                    </div>
                    <div className="form3-row form3-row-2">
                      <div className="form3-field">
                        <label>
                          Recipient Phone<span className="mandate">*</span>
                        </label>
                        <input
                          type="tel"
                          name="recipientPhone"
                          maxLength="20"
                          onChange={this.onChange}
                          value={this.state.recipientPhone}
                          className={submitted && !this.state.recipientPhone ? "form3-input-error" : ""}
                        />
                        {submitted && !this.state.recipientPhone && (
                          <span className="form3-error">Please provide a phone number</span>
                        )}
                      </div>
                      <div className="form3-field">
                        <label>Recipient Email</label>
                        <input
                          type="email"
                          name="recipientEmail"
                          maxLength="40"
                          onChange={this.onChange}
                          value={this.state.recipientEmail}
                        />
                      </div>
                    </div>
                    <div className="form3-row form3-row-2">
                      <div className="form3-field form3-field-lg">
                        <label>
                          Recipient Mailing Address
                          <span className="mandate">*</span>
                        </label>
                        <input
                          type="text"
                          name="recipientAddress"
                          maxLength="40"
                          onChange={this.onChange}
                          value={this.state.recipientAddress}
                          className={submitted && !this.state.recipientAddress ? "form3-input-error" : ""}
                        />
                        {submitted && !this.state.recipientAddress && (
                          <span className="form3-error">Please provide an address</span>
                        )}
                      </div>
                      <div className="form3-field">
                        <label>Apt, PO Box, etc.</label>
                        <input
                          type="text"
                          name="recipientApt"
                          maxLength="40"
                          onChange={this.onChange}
                          value={this.state.recipientApt}
                        />
                      </div>
                    </div>
                    <div className="form3-row form3-row-4">
                      <div className="form3-field">
                        <label>
                          City<span className="mandate">*</span>
                        </label>
                        <input
                          type="text"
                          name="recipientCity"
                          maxLength="20"
                          onChange={this.onChange}
                          value={this.state.recipientCity}
                          className={submitted && !this.state.recipientCity ? "form3-input-error" : ""}
                        />
                        {submitted && !this.state.recipientCity && (
                          <span className="form3-error">Please provide a city</span>
                        )}
                      </div>
                      <div className="form3-field">
                        <label>
                          State<span className="mandate">*</span>
                        </label>
                        <input
                          type="text"
                          name="recipientState"
                          maxLength="2"
                          onChange={this.onChange}
                          value={this.state.recipientState}
                          className={submitted && !this.state.recipientState ? "form3-input-error" : ""}
                        />
                        {submitted && !this.state.recipientState && (
                          <span className="form3-error">Please provide a state</span>
                        )}
                      </div>
                      <div className="form3-field">
                        <label>
                          Zip Code<span className="mandate">*</span>
                        </label>
                        <input
                          type="text"
                          name="recipientZip"
                          maxLength="10"
                          onChange={this.onChange}
                          value={this.state.recipientZip}
                          className={submitted && !this.state.recipientZip ? "form3-input-error" : ""}
                        />
                        {submitted && !this.state.recipientZip && (
                          <span className="form3-error">Please provide a zip code</span>
                        )}
                      </div>
                      <div className="form3-field">
                        <label>Recipient Fax</label>
                        <input
                          type="tel"
                          name="recipientFax"
                          maxLength="20"
                          onChange={this.onChange}
                          value={this.state.recipientFax}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </section>

              {/* ============ SECTION: Delivery Method ============ */}
              <section className="form3-section">
                <h2 className="form3-section-heading">
                  Delivery Method
                  <div className="form3-tooltip">
                    <span className="icon">
                      <img
                        src={ToolTipIcon}
                        width="20px"
                        height="20px"
                        alt="Information"
                      />
                    </span>
                    <span className="text">
                      This identifies where the information is being sent and the format. Our preferred method, "Electronic copy of records," is selected. Alternatively, a fax sent to 972-408-4411 is the next best option.
                    </span>
                  </div>
                </h2>
                <p className="form3-instruction">
                  Select the method of delivery for the records
                </p>
                <div className="form3-pill-group">
                  {DELIVERY_OPTIONS.map((opt) => (
                    <label className={`form3-pill ${this.state.deliveryMethod === opt ? "form3-pill-selected" : ""}`} key={opt}>
                      <input
                        type="radio"
                        name="deliveryMethod"
                        value={opt}
                        checked={this.state.deliveryMethod === opt}
                        onChange={this.onChange}
                      />
                      <span>{opt}</span>
                    </label>
                  ))}
                </div>
                {submitted && !this.state.deliveryMethod && (
                  <span className="form3-error">Please specify a method for delivery</span>
                )}
              </section>

              {/* ============ SECTION: Identity Verification ============ */}
              <section className="form3-section">
                <h2 className="form3-section-heading">
                  Identity Verification
                  <div className="form3-tooltip">
                    <span className="icon">
                      <img
                        src={ToolTipIcon}
                        width="20px"
                        height="20px"
                        alt="Information"
                      />
                    </span>
                    <span className="text">
                      Please upload a driver's license, state-issued identity card. You can always send this information later on, along with your insurance information.
                    </span>
                  </div>
                </h2>
                <p className="form3-instruction">
                  To verify your identity, please upload an image of your valid
                  state ID card.
                </p>
                <div className="form3-file-upload">
                  <label className="form3-file-label" htmlFor="idFileInput">
                    <span className="form3-file-icon">&#8679;</span>
                    <span>
                      {this.state.idFileName ||
                        "Drag & drop or Click to browse"}
                    </span>
                  </label>
                  <input
                    id="idFileInput"
                    type="file"
                    accept=".pdf,.png,.jpg,.jpeg,.tiff"
                    onChange={this.onFileChange}
                    style={{ display: "none" }}
                  />
                </div>
              </section>

              {/* ============ SECTION: Additional Information ============ */}
              <section className="form3-section">
                <h2 className="form3-section-heading">
                  Additional Information
                </h2>
                <p className="form3-instruction">
                  Please provide any additional information pertinent to this
                  request
                </p>
                <div className="form3-row form3-row-1">
                  <div className="form3-field form3-field-full">
                    <label>
                      Additional Information (Maximum of 500 characters)
                    </label>
                    <textarea
                      name="additionalInfo"
                      maxLength="500"
                      rows="3"
                      onChange={this.onChange}
                      value={this.state.additionalInfo}
                    />
                  </div>
                </div>
              </section>

              {/* ============ Disclaimer & Submit ============ */}
              <section className="form3-section form3-disclaimer">
                <p>
                  I understand that the specified information to be released may
                  include, but is not limited to, history, diagnoses and/or
                  treatment of drug or alcohol abuse, mental illness or
                  communicable disease including Human Immunodeficiency Virus
                  (HIV) and Acquired Immune Deficiency Syndrome (AIDS).
                </p>
                <p style={{ marginTop: "10px" }}>
                  A fee covering the costs of labor, supplies and postage
                  associated with these records may apply to this request. If a
                  fee does apply, you will be notified before your request is
                  processed.
                </p>
              </section>

              <div className="form3-submit">
                <button type="submit" className="form3-submit-btn">
                  Submit Request
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Loading overlay */}
        {this.state.loading && (
          <div className="loader-container">
            <div className="loader-content">
              <div className="loader"></div>
              <span className="loader-text">Submitting...</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Form3);
